import React from "react";
import { Divider, Paper } from "convertupleads-theme";
import BasicRadio from "./BasicRadio/BasicRadio";
import PageTitleBox from "../../../common/PageTitleBox";

const RadioPage = () => {
  return (
    <Paper elevation={0}>
      <PageTitleBox
        title={"Radio Group"}
        description={
          "The Radio Group allows the user to select one option from a set."
        }
      />
      <Divider light />
      <BasicRadio />
    </Paper>
  );
};

export default RadioPage;
